
import {
  defineComponent,
  ref,
  onMounted,
  watch,
} from 'vue';
import {
  message,
  Modal,
} from 'ant-design-vue';
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import baseInfo from './baseInfo.vue';
// import rightInfo from './rightInfo.vue';

import authority from '@/components/authority/index.vue';
import logInfo from './logInfo.vue';
import { randomString, } from '@/utils/index';
import {
  updateRight,registerTrialUser,updateUser, openOrRefuseTrialUser,
} from '../../accountReq';

export default defineComponent({
  components: {
    Modal,
    baseInfo,
    authority,
    logInfo,
  },
  props: {
    modalType: {
      type: String,
      default: () => 'add',
      require: true,
    },
    dataType: {
      type: Number,
      default: () => 0,
      require: true,
    },
    showPopLog: {
      type: Boolean,
      default: () => true,
      require: false,
    },
    roleData: {
      type: String,
      default: () => '',
      require: false,
    },
  },
  setup (props, { emit, }) {
    const currentModalType = ref<string>('add');
    const title = ref<string>('新增');
    const tabButton = ref<any>({});

    tabButton.value = props.showPopLog ? {
      basic: '基本信息',
      menu: '账号权限',
      log: '操作日志',
    } :
      {
        basic: '基本信息',
        menu: '账号权限',
      };
    const rightInfolRef = ref<any>(null);
    const selectTab = ref<any>('basic');
    // 是否有权限设置
    const isOp = ref<boolean>(false);
    const isTip = ref<boolean>(false);

    const selectTerminalTip = ref<boolean>(false);

    const rightChange = (val:boolean) => {
      if (typeof val !== 'boolean') return;
      isOp.value = val;
      if (val) {
        isTip.value = false;
        selectTerminalTip.value = false;
      }
    };
    const checkedTerminal = (flag:boolean) => {
      if (flag) {
        selectTerminalTip.value = false;
      }
    };
    const baseRef = ref<any>();

    const handleCancle = () => {
      emit('cancelModal');
    };

    const handleSave = () => {
      const list = baseRef.value.handleSave();

      if (!list) {
        return;
      }

      if (!rightInfolRef.value) {
        return;
      }
      const getTerminalSelected = rightInfolRef.value.getTerminalSelected();

      if (!getTerminalSelected || !getTerminalSelected.length) {
        selectTerminalTip.value = true;

        return;
      }

      const ticketRadioChecked = rightInfolRef.value.getTicketRadioChecked();

      if (!ticketRadioChecked) {
        return message.warning('请配置工单数据权限');
      }

      if (!isOp.value && getTerminalSelected.includes('mobile') === -1) {
        isTip.value = true;

        return;
      }

      selectTerminalTip.value = false;

      const rightParams = rightInfolRef.value.getCurRights();

      list.accountType = props.dataType;
      list.headerIcon = '';
      list.roleCode = randomString(6);

      const { menuIds, } = rightParams;

      if (props.modalType === 'edit') {
        rightParams.regionId = list.regionId;
        Promise.all([updateRight(rightParams),updateUser(list),]).then((res:any) => {
          emit('saveModal');
        });
      } else if (props.modalType === 'add') {
        if (list && Object.keys(list).length > 0) {
          list.menuIds = menuIds;
          registerTrialUser(list).then((result:any) => {
            emit('saveModal');
          });
        }
      } else if (props.modalType === 'pass') {
        const params = {
          id: list.id,
          isOpen: 1,
          menuIds: rightParams.menuIds,
        };

        openOrRefuseTrialUser(params).then((result:any) => {
          emit('saveModal');
        });
      }
    };

    const clickTabButton = (val: string) => {
      selectTab.value = val;
    };
    const closeTip = () => {
      isTip.value = false;
      selectTerminalTip.value = false;
    };

    onMounted(() => {
      //
    });

    return {
      zhCN,
      currentModalType,
      title,
      tabButton,
      selectTab,
      isOp,
      isTip,
      rightInfolRef,
      baseRef,
      selectTerminalTip,

      handleCancle,
      handleSave,
      rightChange,
      checkedTerminal,
      clickTabButton,
      closeTip,
    };
  },
});
